export default "__VITE_ASSET__DMxe3lpF__"